// extracted by mini-css-extract-plugin
export default {"MainContainer":"_MainContainer--BZcOu","Header":"_Header--T8r5i","ExtensionsContainer":"_ExtensionsContainer--usCp1"};